import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import './CardBank.css';
import { getRefreshTokin, getBankApi, keys, sendFilter } from '../api/api';
import { Button, Modal, Select, message, Radio, Input, Form } from 'antd';
import SortAscendingOutlined from '@ant-design/icons/lib/icons/SortAscendingOutlined';
import SortDescendingOutlined from '@ant-design/icons/lib/icons/SortDescendingOutlined';
import { nanoid } from 'nanoid';
let filterObj: any = {};

const CardBank = () => {
  //Для всплывающего модального окна

  const [visible, setVisible] = useState(false);
  //Для вывода в модальное окно всей инфы по банкам
  const [data, setData] = useState<any>([]);
  //Для изменения названия тега
  const { Option } = Select;
  //Для всплывающего сообщения
  const [bankData, setBankdata] = useState<any>([]);
  //Для всплывающего сообщения
  const key = 'updatable';

  //Срабатывает при вводе цифр
  //Для создания массива фильтра и отправки на сервер для фильтрации по банкам
  const onInputChange = (e: any) => {
    //Проверка на цифры
    if (e.target.value <= 999999999) {
      //Если значение пусто то пишем в нем "0"
      if (e.target.value) {
        filterObj[e.target.name] = [e.target.name, e.target.form.innerText, e.target.value];
      } else {
        delete filterObj[e.target.name];
      }

      //отправка на бд
      sendFilter(filterObj).then((res) => {
        setBankdata(res);
        message.success({ content: 'Готово!', key, duration: 1 });
      });
    } else {
      message.error({ content: 'Нужно ввести цифры!', key, duration: 1 });
    }
  };

  //Для overstatement создание массива и отправка
  const optionsClick = (e: any) => {
    filterObj['overstatement'] = e;

    sendFilter(filterObj).then((res) => {
      setBankdata(res);
      message.success({ content: 'Готово!', key, duration: 1 });
    });
  };

  //для да, нет и для сортировки по алфавиту
  const onFilterClick = (e: any) => {
    filterObj[e.target.name] = e.target.value;

    sendFilter(filterObj).then((res) => {
      setBankdata(res);
      message.success({ content: 'Готово!', key, duration: 1 });
    });
  };
  const bankApi = () => {
    const catchError = () => {
      getRefreshTokin()
        .then((res: any) => res.json())
        .then((res) => {
          localStorage.access_token = res.access_token;
          bankApi();
        })
        .catch(() => {
          localStorage.removeItem('access_token');
        });
    };
    getBankApi()
      .then((res: any) => res.json(), message.loading({ content: 'Загрузка...', key }))
      .then((res: any) => {
        if (res.message) {
          catchError();
        } else {
          setBankdata(res);
          message.success({ content: 'Готово!', key, duration: 2 });
        }
      })
      .catch(catchError);
  };

  useEffect(() => {
    bankApi();
    filterObj = {};
  }, []);

  //Для отображения на input ввода числа сравнительных знаков
  const selectAfter = (
    <Select
      defaultValue=">="
      style={{
        width: 70,
      }}
    >
      <Option value=">=">{'>='}</Option>
      <Option value="<=">{'<='}</Option>
    </Select>
  );

  return (
    <>
      <section className="wrapper__bank-section">
        <div className="card__wrapper">
          <div className="bank__wrapper">
            {bankData?.map((i: any) => {
              return (
                <div key={i?.id} className="bank">
                  <div className="bank__img">
                    {i?.logo?.type !== null ? (
                      <img
                        src={i?.logo?.type}
                        alt=""
                        onError={({ currentTarget }) => {
                          currentTarget.src =
                            'https://cdn0.iconfinder.com/data/icons/documents-50/32/undefined-document-512.png';
                        }}
                      />
                    ) : (
                      <img src="https://cdn0.iconfinder.com/data/icons/documents-50/32/undefined-document-512.png" />
                    )}
                  </div>
                  <div className="bank__cotent">
                    <div className="bank__title">{i?.title?.type}</div>
                    <div className="bank__text"></div>
                    <Button
                      onClick={() => {
                        setVisible(true);
                        setData(i);
                      }}
                    >
                      Подробнее
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <>
          <Modal
            title={data?.title?.type}
            centered
            open={visible}
            onOk={() => setVisible(false)}
            onCancel={() => setVisible(false)}
            width={1200}
            className="modal__bank"
          >
            {Object.entries(data).map((i: any) => {
              const key = nanoid();
              if (
                i[1].title === 'Название банка' ||
                i[1].title === 'Логотип' ||
                i[1].title === 'Дата изменения ' ||
                i[1].title === undefined
              ) {
                return null;
              } else {
                if (i[1]?.filter !== undefined && i[1]?.num === undefined) {
                  return (
                    <div key={key} className="modal_bank_card">
                      <strong>
                        {i[1].title} :{' '}
                        <strong style={{ color: 'red' }}>{i[1]?.filter ? ' Да' : ' Нет'}</strong>
                      </strong>
                      <div style={{ marginBottom: 10 }}>{i[1]?.comment ? 'Коментарии' : null}</div>
                      <div>{i[1]?.comment ? i[1]?.comment : null}</div>
                    </div>
                  );
                } else if (i[1]?.type !== undefined) {
                  return (
                    <div key={key} className="modal_bank_card">
                      <strong>
                        {i[1].title} :
                        <strong style={{ color: 'red' }}>{i[1]?.type ? i[1]?.type : null}</strong>
                      </strong>
                      <div style={{ marginBottom: 10 }}>{i[1]?.comment ? 'Коментарии' : null}</div>
                      <div>{i[1]?.comment ? i[1]?.comment : null}</div>
                    </div>
                  );
                } else {
                  return (
                    <div key={key} className="modal_bank_card">
                      <strong>
                        {i[1].title} :
                        <strong style={{ color: 'red' }}>{i[1]?.num ? i[1]?.num : null}</strong>
                      </strong>
                      <div style={{ marginBottom: 10 }}>{i[1]?.comment ? 'Коментарии' : null}</div>
                      <div>{i[1]?.comment ? i[1]?.comment : null}</div>
                    </div>
                  );
                }
              }
            })}
          </Modal>
        </>
        <div id="filter" className="filter__wrapper">
          <Button
            onClick={() => {
              if (Object.keys(filterObj).length !== 0) window.location.reload();
            }}
            className="filter__clear-button"
          >
            Очистить фильтр
          </Button>
          {keys?.map((fil: any, index: number) => {
            if (fil[2] == 'a-z') {
              return (
                <div key={index} className="wrapper__item-filter">
                  <div className="item__filter-title">{fil[0]}</div>
                  <Radio.Group
                    defaultValue={''}
                    name={fil[1]}
                    buttonStyle="solid"
                    onChange={onFilterClick}
                  >
                    <Radio.Button value="a">
                      <SortAscendingOutlined value="a" name="title" />
                    </Radio.Button>
                    <Radio.Button value="z">
                      <SortDescendingOutlined value="z" name="title" />
                    </Radio.Button>
                    <Radio.Button value={''}>Не выбрано</Radio.Button>
                  </Radio.Group>
                </div>
              );
            } else {
              if (fil[2] == 'int') {
                if (fil[1] === 'limit_client' || fil[1] === 'bg_size' || fil[1] === 'limit_bg') {
                  return (
                    <div key={index} className="wrapper__item-filter">
                      <div className="item__filter-title">{fil[0] + '(в рубли/единицы)'}</div>
                      <Form onFinish={onInputChange} key={fil[1]}>
                        <Form.Item name={fil[1]}>
                          <Input
                            addonAfter={selectAfter}
                            maxLength={9}
                            name={fil[1]}
                            onChange={onInputChange}
                          ></Input>
                        </Form.Item>
                      </Form>
                    </div>
                  );
                } else {
                  return (
                    <div key={index} className="wrapper__item-filter">
                      <div className="item__filter-title">{fil[0] + '(в месяц/единицы)'}</div>
                      <Form onFinish={onInputChange} key={fil[1]}>
                        <Form.Item name={fil[1]}>
                          <Input
                            addonAfter={selectAfter}
                            maxLength={3}
                            name={fil[1]}
                            onChange={onInputChange}
                          ></Input>
                        </Form.Item>
                      </Form>
                    </div>
                  );
                }
              } else {
                if (fil[1] == 'overstatement') {
                  return (
                    <div key={index} className="wrapper__item-filter">
                      <div className="item__filter-title">Завышение</div>
                      <Select
                        defaultValue="Выберите"
                        style={{ width: 120 }}
                        onChange={optionsClick}
                      >
                        <Option name={fil[1]} value={''}>
                          Выберите
                        </Option>
                        <Option name={fil[1]} value="x2">
                          x2
                        </Option>
                        <Option name={fil[1]} value="x3">
                          x3
                        </Option>
                        <Option name={fil[1]} value="x5">
                          x5
                        </Option>
                        <Option name={fil[1]} value="Запрещено">
                          Запрещено
                        </Option>
                      </Select>
                    </div>
                  );
                } else
                  return (
                    <div key={index} className="wrapper__item-filter">
                      <div className="item__filter-title">{fil[0]}</div>
                      <Radio.Group
                        defaultValue={''}
                        name={fil[1]}
                        buttonStyle="solid"
                        onChange={onFilterClick}
                      >
                        <Radio.Button value={true}>Да</Radio.Button>
                        <Radio.Button value={false}>Нет</Radio.Button>
                        <Radio.Button value={''}>Не выбрано</Radio.Button>
                      </Radio.Group>
                    </div>
                  );
              }
            }
          })}
        </div>
      </section>
    </>
  );
};

export default CardBank;
